<div class="text-right marT20">
  <button type="button" class="clickBtn" (click)="exportReport()">
    Export Report
  </button>
</div>

<table>
  <thead>
    <th *ngFor="let column of sampleColumns" [ngStyle]="{width: column.width, minWidth: column.minWidth}">
      <div>
        <span> {{column.header}} </span>
      </div>
    </th>
  </thead>

  <tbody>
    <tr *ngFor="let auditData of auditTrailList">
      <td>{{auditData.FormattedCreatedOrUpdatedDate}}</td>
      <td>{{auditData.FieldName}}</td>
      <td>{{auditData.OriginalValue}}</td>
      <td>{{auditData.NewValue}}</td>
      <td>{{auditData.UserAction}}</td>
      <td>{{auditData.CreatedBy}}</td>
    </tr>
  </tbody>
</table>